/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-props-no-spreading */
import { Link as SpectrumLink } from "@adobe/react-spectrum";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useJsonForms, withJsonFormsLayoutProps } from "@jsonforms/react";
import { getEndpointName } from "@apollo/jsonforms-react-spectrum-renderers/src/util/commonUtils";
import { get } from "lodash";
import { useSelector } from "react-redux";
import {
  evaluateContextRule,
  extractPath,
  resolveContextValue,
} from "../utils/commonUtils";
// import { imsActions } from "../components/IMS";
// import { ImsAuthContext } from "../context/IMSAuthContext";
declare const window: any;

export const hyperLinkButtonRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("Link")
);

function HyperLinkRenderer({ uischema, visible }: RendererProps) {
  let linkJsx = <></>;

  // const { imsActions } = useContext(ImsAuthContext)!;

  const type = uischema.options?.redirect?.type;
  let path = uischema.options?.redirect?.path;
  let label = uischema.options?.label;
  const reduxStateObj = useSelector((state: any) => state?.reduxState);
  const contextContent = resolveContextValue(reduxStateObj, label);
  if (contextContent) {
    label = contextContent;
  }
  const spectrumProps = uischema.options?.spectrumProps;
  const style = uischema.options?.style;
  const className = uischema.options?.className;
  const newTab = uischema.options?.newTab;
  const actionType = uischema.options?.redirect?.actionType;
  const endpointPath = uischema.options?.endpointPath;
  const redirectPath = uischema.options?.redirect?.redirectPath;
  const context = useJsonForms();
  const onClickCallback =
    context?.config?.lifecycleHooks?.onSuccessCallbacks?.hyperLink;

  const onHandleClick = onClickCallback?.onHandleClick;
  const data = context?.core?.data || {};
  function handleClick() {
    if (onHandleClick) {
      onHandleClick({ isClicked: true, actionType, data });
    }
  }
  if (endpointPath) {
    const pathKey = getEndpointName(endpointPath, context?.config);
    const endpoint = get(context?.config, pathKey, "");
    path = endpoint + path;
  }

  const contextValue = resolveContextValue(reduxStateObj, path);
  if (typeof contextValue !== "undefined") {
    path = contextValue;
  }

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  switch (type) {
    case "route":
      linkJsx = newTab ? (
        <RouterLink to={path} target="__blank" hidden={!componentVisibility}>
          {label}
        </RouterLink>
      ) : (
        <RouterLink to={path} hidden={!componentVisibility}>
          {label}
        </RouterLink>
      );

      break;

    case "external":
      linkJsx = newTab ? (
        <a href={path} target="__blank" hidden={!componentVisibility}>
          {label}
        </a>
      ) : (
        <a href={path} hidden={!componentVisibility}>
          {label}
        </a>
      );
      break;
    case "onClick":
    case "IMSLogin":
    case "IMSRegister":
      linkJsx = <div>{label}</div>;
      break;
    default:
      break;
  }
  if (type === "onClick") {
    return (
      <SpectrumLink
        {...spectrumProps}
        UNSAFE_style={style}
        UNSAFE_className={className}
        data-testid="link"
        onPress={() => handleClick()}
        isHidden={!componentVisibility}
      >
        {linkJsx}
      </SpectrumLink>
    );
  }
  return type === "IMSLogin" || type === "IMSRegister" ? (
    <SpectrumLink
      UNSAFE_style={style}
      {...spectrumProps}
      data-testid="link"
      onPress={() => {
        // If there is a handleClick callback, call it before redirecting to IMS
        handleClick();

        // window.adobeIMS.setRedirectURI(window.location.origin + path);
        if (redirectPath) {
          try {
            localStorage.setItem("RedirectPath", redirectPath);
          } catch (error) {
            /* empty */
          }
        }
        if (type === "IMSRegister") {
          window.adobeIMS.signUp();
        } else {
          window.adobeIMS.signIn();
        }
      }}
      isHidden={!componentVisibility}
    >
      {linkJsx}
    </SpectrumLink>
  ) : (
    <SpectrumLink
      onPress={() => handleClick()}
      UNSAFE_style={style}
      {...spectrumProps}
      data-testid="link"
      isHidden={!componentVisibility}
    >
      {linkJsx}
    </SpectrumLink>
  );
}

export default withJsonFormsLayoutProps(HyperLinkRenderer);
